import authSdk from '../sdk'

const warehouse = authSdk.createAxiosInstance({
    baseURL: import.meta.env.APP_WAREHOUSE_API_URL,
})

export default warehouse
